import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  item: {
    icon: ReactNode;
    title: string;
    description: string;
    link?: string;
    onclick?: () => void;
    disabled?: boolean;
  };
};
const BusinessCard = ({ item }: Props) => {
  return (
    <div key={item.title} className='w-full'>
      {item.link ? (
        <Link
          to={item.disabled ? '#' : item.link}
          preventScrollReset
          className={`border border-[#EFF0F0] rounded-md p-5 space-y-3 w-full block ${
            item.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
          }`}>
          <div className='bg-[#F4F1F1] w-[50px] h-[50px] rounded-full flex items-center justify-center'>
            {item.icon}
          </div>
          <h2 className='text-[#2E3031] text-[16px] font-medium'>{item.title}</h2>
          <p className='text-[#6F7376] text-sm'>{item.description}</p>
        </Link>
      ) : (
        <div
          className={`border border-[#EFF0F0] rounded-md p-5 space-y-3 w-full ${
            item.disabled ? 'cursor-not-allowed' : ' cursor-pointer'
          }`}
          onClick={() => !item.disabled && item.onclick?.()}>
          <div className='bg-[#F4F1F1] w-[50px] h-[50px] rounded-full flex items-center justify-center'>
            {item.icon}
          </div>
          <h2 className='text-[#2E3031] text-[16px] font-medium'>{item.title}</h2>
          <p className='text-[#6F7376] text-sm'>{item.description}</p>
        </div>
      )}
    </div>
  );
};

export default BusinessCard;
